/**
 * Remove from input value after masking special characters - spaces and braces
 * @param value
 * @param removePlus
 */
export function removePhoneSpecialCharacters(value: string, removePlus = false): string {
  return String(value).replace(removePlus ? /[() +]/g : /[() ]/g, '');
}
